import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "./url-handler.service";

const TopProductsCatalogApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  //Selection Groups API
  createItemSelectionGroup(data) {
    return Vue.axios.post(`${this.URL}/api/shop/item-selection-groups`, data);
  },

  updateItemSelectionGroup(id, data) {
    return Vue.axios.put(`${this.URL}/api/shop/item-selection-groups/${id}`, data);
  },

  deleteItemSelectionGroup(id) {
    return Vue.axios.delete(`${this.URL}/api/shop/item-selection-groups/${id}`);
  },

  getAllItemSelectionGroups(params = {}) {
    return Vue.axios.get(`${this.URL}/api/shop/item-selection-groups`, { params });
  },

  exportSelectionGroup(selectionGroupId) {
    return Vue.axios.get(`${this.URL}/api/shop/catalog/export/selection-group`, {
      params: { selectionGroupId },
      responseType: "blob"
    });
  },

  exportCategories() {
    return Vue.axios.get(`${this.URL}/api/shop/catalog/export/categories`, {
      responseType: "blob"
    });
  },

  importSelectionGroup(selectionGroupId, mode, file) {
    return Vue.axios.post(
      `${this.URL}/api/shop/catalog/export/selection-group/import`,
      file,
      {
        params: { selectionGroupId, mode },
        headers: { "Content-Type": "text/plain" }
      }
    );
  },

  //Item Selections API
  createItemSelection(data) {
    return Vue.axios.post(`${this.URL}/api/shop/item-selections`, data);
  },

  getItemSelectionById(id) {
    return Vue.axios.get(`${this.URL}/api/shop/item-selections/${id}`);
  },

  updateItemSelection(id, data) {
    return Vue.axios.put(`${this.URL}/api/shop/item-selections/${id}`, data);
  },

  deleteItemSelection(id) {
    return Vue.axios.delete(`${this.URL}/api/shop/item-selections/${id}`);
  },

  deleteBulkItemSelections(ids) {
    return Vue.axios.delete(`${this.URL}/api/shop/item-selections/batch`, { data: ids });
  },

  getAllItemSelections(params = {}) {
    return Vue.axios.get(`${this.URL}/api/shop/item-selections`, { params });
  }
};

export default TopProductsCatalogApiService;
